// @flow

import React from 'react';
import './termsandconditionspage.scss';

type Props = {
  user: any,
};

class TermsAndConditionsPage extends React.Component<Props> {
  logout = () => {
    localStorage.clear();
    // eslint-disable-next-line no-restricted-globals
    location.href = '/account/signout';
  }

  goToPRSfM() {
    localStorage.clear();
    // eslint-disable-next-line no-restricted-globals
    location.href = 'https://www.prsformusic.com/login';
  }

  render() {
    const { user } = this.props;
    return user && !user.termsAccepted && (
      <div className="generic_modal main-content terms-and-conditions d-flex flex-column" data-toggle="modal">
        <header>
          <h1><p>Terms & Conditions</p></h1>
        </header>
        <div className="terms-and-conditions--body flex-grow-1">
          <p>
            We have detected that you have logged
            into your PRS for Music
            online account for the first time. Before you can use our mobile app you will need to:
            <ol>
              <li>Select proceed</li>
              <li>Log in to the PRS for Music website in the newly opened browser window</li>
              <li>Accept the terms and conditions</li>
              <li>Log out of the PRS for Music website</li>
              <li>Close and re-open the app</li>
            </ol>
          </p>
        </div>
        <footer>
          <button
            onClick={this.goToPRSfM}
            className="btn btn-prs lime-bg btn-block"
            type="button"
          >
            Proceed
          </button>
          <button className="btn btn-default btn-block" type="button" onClick={() => this.logout()}>
            Log out
          </button>
        </footer>
      </div>
    );
  }
}

export default TermsAndConditionsPage;
